// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3e8js","footer":"styles_footer__13k1T","passCodeTooltip":"styles_passCodeTooltip__3Kvq0"};